module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Warning-1-circle-93d81bcc1d8da8ef9bbbeaa61775724e.svg";